// CreateNews
import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import TextField from '@material-ui/core/TextField'
import CropperImage from "../CropperImage";
import ImageUploading from "react-images-uploading";
import { Row, Col } from "react-bootstrap";
import ImageResize from "image-resize";
import Resizer from "react-image-file-resizer";
import '../component.css'
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: theme.spacing.unit / 4,
    },
    noLabel: {
        marginTop: theme.spacing.unit * 3,
    },
    inputColor: {
        backgroundColor: "#F4F6F9",
        borderRadius: "5px",
        borderWidth: "0",
    },
}));

export const CreateWeeklypass = (props) => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    const classes = useStyles();
    suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create Weekly check in" }));
    const history = useHistory();

    const [item_image_path, setItem_image_path] = useState();
    const [item_image_path2, setItem_image_path2] = useState();
    const [nameImageItem_image_path, setNameImageItem_image_path] = useState("");
    const [nameImageItem_image_path2, setNameImageItem_image_path2] = useState("");
    const [displayOrder, setDisplayOrder] = useState(0)
    const [popupstart, setPopupstart] = useState();
    const [popupend, setPopupend] = useState();
    const [nameTH, setNameTH] = useState()
    const [nameEN, setNameEN] = useState()
    const [descriptionTH, setDescriptionTH] = useState()
    const [descriptionEN, setDescriptionEN] = useState()
    const [point, setPoint] = useState()
    const [img1, setIMG1] = useState()
    const [img2, setIMG2] = useState()
    const [symbolsArr] = useState(["e", "E", "+", "-"])




    let dataTemp = []
    const [images, setImages] = React.useState([]);
    const maxNumber = 10;
    /*const onChange = async (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
        if (imgCount == 0) {
            console.log('x', imgCount)
            setImgCount(imageList.length)
            await Promise.all(imageList.map(async (item, index) => {
                await handleUpload_image_Details(item.file)
            }))
        } else {
            console.log('y', imgCount)

            if (imageList.length > imgCount) {
                await Promise.all(imageList.map(async (item, index) => {
                    if (index > imgCount - 1) {
                        await handleUpload_image_Details(item.file)
                    }
                }))
                setImgCount(imageList.length)

            }
        }

        console.log('img', listImg)
    };*/

    const [stateItem_image_path, setStateItem_image_path] = useState({
        previewItem_image_path: null,
        rawItem_image_path: null,
        imageURLItem_image_path: null,
    });

    const [stateItem_image_path2, setStateItem_image_path2] = useState({
        previewItem_image_path: null,
        rawItem_image_path: null,
        imageURLItem_image_path: null,
    });


    /*const removeListIMG = (index) => {
        console.log(index)
        let arr = listImg
        arr.splice(index, 1);

        console.log(arr)

        setListImg(arr)
    }*/

    const handleChangeItem_image_path = async (e) => {
        if (e.target.files.length) {
            e.preventDefault();
            let file = e.target.files[0];
            var reader = new FileReader();
            e.target.value = '';
            handleImageUploadItem_image_path(file)
        }
    };

    const handleChangeItem_image_path2 = async (e) => {
        if (e.target.files.length) {
            e.preventDefault();
            let file = e.target.files[0];
            var reader = new FileReader();
            e.target.value = '';
            handleImageUploadItem_image_path2(file)
        }
    };


    const removeImageItem_image_path = async () => {
        setStateItem_image_path({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
        });
        setItem_image_path("");
    };

    const removeImageItem_image_path2 = async () => {
        setStateItem_image_path2({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
        });
        setItem_image_path("");
    };

    const AlertError = (message) => {
        Swal.fire("Alert", message, "error");
    };

    const ISOString = (data) => {
        console.log(`${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`)
        return `${data.toString().substring(0, 10)} ${data.toString().substring(11, 16)}`
        // console.log(Date(data).toISOString())
    };



    const handleCancelUploadItem_image_path = () => {
        setStateItem_image_path({
            previewItem_image_path: null,
            rawItem_image_path: null,
            imageURLItem_image_path: null,
        });
    };

    const handleImageUploadItem_image_path = async (file) => {
        const image = await resizeFile(file);
        console.log(image)
        console.log(file)
        imageResize
            .play(URL.createObjectURL(file))
            .then(async function (response) {
                console.log(response)
                const trans = dataURLtoFile(image, 'img.png')
                var formdata = new FormData();
                let token = localStorage.getItem("Token");
                formdata.append("image", trans, URL.createObjectURL(trans));

                var requestOptions = {
                    method: "POST",
                    body: formdata,
                    redirect: "follow",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                };
                fetch(`${baseURLV1}/upload`, requestOptions)
                    .then((response) => response.text())
                    .then((result) => {
                        let res = JSON.parse(result);
                        setStateItem_image_path({
                            previewItem_image_path: null,
                            rawItem_image_path: null,
                            imageURLItem_image_path: null,
                        });
                        let fullPath = `${baseURL}/uploads/${res.filename}`
                        setItem_image_path(fullPath);
                        setIMG1(res.filename);
                        setNameImageItem_image_path(fullPath);
                    })
                    .catch((error) => console.log("error", error));
            })

    };

    const handleImageUploadItem_image_path2 = async (file) => {
        const image = await resizeFile(file);
        console.log(image)
        console.log(file)
        imageResize
            .play(URL.createObjectURL(file))
            .then(async function (response) {
                console.log(response)
                const trans = dataURLtoFile(image, 'img.png')
                var formdata = new FormData();
                let token = localStorage.getItem("Token");
                formdata.append("image", trans, URL.createObjectURL(trans));

                var requestOptions = {
                    method: "POST",
                    body: formdata,
                    redirect: "follow",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                };
                fetch(`${baseURLV1}/upload`, requestOptions)
                    .then((response) => response.text())
                    .then((result) => {
                        let res = JSON.parse(result);
                        setStateItem_image_path2({
                            previewItem_image_path: null,
                            rawItem_image_path: null,
                            imageURLItem_image_path: null,
                        });
                        let fullPath = `${baseURL}/uploads/${res.filename}`
                        setItem_image_path2(fullPath);
                        setIMG2(res.filename);
                        setNameImageItem_image_path2(fullPath);
                    })
                    .catch((error) => console.log("error", error));
            })

    };

    const imageResize = new ImageResize({
        format: "png", // ไฟล์รูปภาพเป็น png
        quality: 0.5, // ปรับขนาดไฟล์รูปภาพให้เหลือครึ่งนึง
        width: 500, // ปรับขนาดรูปให้มีความกว้าง 500 px
    });




    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                3000,
                "PNG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });


    /*const handleUpload_image_Details = async (file) => {
        const image = await resizeFile(file);
        imageResize
            .play(URL.createObjectURL(file)) //แปลงไฟล์เป็น blob
            .then(async function (response) {
                const trans = dataURLtoFile(image, 'img.png')
                var formdata = new FormData();
                let token = localStorage.getItem("Token");
                formdata.append("image", trans, URL.createObjectURL(trans));
                var requestOptions = {
                    method: "POST",
                    body: formdata,
                    redirect: "follow",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                };
                await fetch(`${baseURLV1}/upload`, requestOptions)
                    .then((response) => response.text())
                    .then((result) => {
                        let res = JSON.parse(result);
                        let fullPath = `${baseURL}/uploads/${res.filename}`

                        //setListImg(listImg => [...listImg, fullPath])
                    })
                    .catch((error) => console.log("error", error));
            })
            .catch(function (error) {
                console.error(error);
            });
    };*/

    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }


    const onSubmit = async (data) => {
        let img = {}
        if (nameTH === undefined || nameTH === "") {
            return AlertError("Please insert banner catagory !!");
        }

        if (nameEN === undefined || nameEN === "") {
            return AlertError("Please insert banner catagory !!");
        }
        if (descriptionTH === undefined || descriptionTH === "") {
            return AlertError("Please insert banner catagory !!");
        }
        if (descriptionEN === undefined || descriptionEN === "") {
            return AlertError("Please insert banner catagory !!");
        }
        if (point === undefined || point === "") {
            return AlertError("Please insert banner catagory !!");
        }


        if (img1 === undefined || img1 === "") {
            return AlertError("Please insert link !!");
        }

        if (img2 === undefined || img2 === "") {
            return AlertError("Please insert weight !!");
        }

        if (popupend === undefined || popupend === "") {
            return AlertError("Please insert image th!!");
        }

        if (popupstart === undefined || popupstart === "") {
            return AlertError("Please insert image en!!");
        }




        var events = {
            title_th: nameTH,
            title_en: nameEN,
            description_th: descriptionTH,
            description_en: descriptionEN,
            image_th: img1,
            image_en: img2,

            start_date: popupstart,
            end_date: popupend,
            point: point,
            order_item: displayOrder,


        };

        let apiUrls = `${baseURLV1}/weeklyPass`;
        let token = localStorage.getItem("Token");
        console.log(events)
        const resultAll = axios({
            method: "post",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            data: events,
        })
            .then(async (res) => {
                history.goBack();
            })
            .catch((err) => {
                Swal.fire(
                    "Alert",
                    "Your can not create Banner. !! " + err,
                    "error"
                );
            });
    };


    return (
        <>
            <Card>
                <CardHeader title="Create Weekly check in "></CardHeader>
                <CardBody>
                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "สัปดาห์ (TH)" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
                        </p>
                        <input
                            name="topic"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={nameTH}
                            onChange={(e) => setNameTH(e.target.value)}
                        />

                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "สัปดาห์ (EN)" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
                        </p>
                        <input
                            name="topic"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={nameEN}
                            onChange={(e) => setNameEN(e.target.value)}
                        />

                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "เดือน (TH)" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
                        </p>
                        <input
                            name="topic"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={descriptionTH}
                            onChange={(e) => setDescriptionTH(e.target.value)}
                        />

                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "เดือน (EN)" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
                        </p>
                        <input
                            name="topic"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={descriptionEN}
                            onChange={(e) => setDescriptionEN(e.target.value)}
                        />

                    </div>


                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "รูปภาพไอคอน (TH)" })}<span style={{ color: "red" }}>
                                *
                            </span>:
                            <br></br>ควรมีขนาด 150*150
                        </p>
                        <div
                            className="d-flex"
                            style={{
                                width: "530px",
                            }}>
                            <input
                                name="item_image_path"
                                style={{
                                    flexGrow: "1",
                                    height: "38px",
                                    backgroundColor: "#F4F6F9",
                                    borderRadius: "5px",
                                    borderWidth: "0",
                                }}
                                value={item_image_path}
                            />

                            <span className="btn btn-primary btn-file wbt"
                                style={{
                                    whiteSpace: "nowrap",
                                    width: "fit-content"
                                }}>
                                {intl.formatMessage({ id: "104025", defaultMessage: "Upload/Edit" })}
                                <input type="file" onChange={handleChangeItem_image_path} />
                            </span>

                            <button
                                type="button"
                                className="btn btn-danger wbt"
                                onClick={removeImageItem_image_path}
                            >
                                {intl.formatMessage({ id: "104026", defaultMessage: "delete" })}
                            </button>
                            <p style={{ position: 'absolute', marginTop: '40px' }}>ไม่ควรเกิน 1 MB</p>
                        </div>
                    </div>

                    <div
                        style={{
                            display: "block",
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: "50%",
                        }}
                    >
                        {stateItem_image_path.imageURLItem_image_path ? (
                            <img
                                style={{
                                    width: "150px",
                                }}
                                src={stateItem_image_path.imageURLItem_image_path}
                            />
                        ) : item_image_path ? (
                            <img
                                style={{
                                    width: "150px",
                                }}
                                src={item_image_path}
                            />
                        ) : null}
                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "รูปภาพไอคอน (EN)" })}<span style={{ color: "red" }}>
                                *
                            </span>:
                            <br></br>ควรมีขนาด 150*150
                        </p>
                        <div
                            className="d-flex"
                            style={{
                                width: "530px",
                            }}>
                            <input
                                name="item_image_path"
                                style={{
                                    flexGrow: "1",
                                    height: "38px",
                                    backgroundColor: "#F4F6F9",
                                    borderRadius: "5px",
                                    borderWidth: "0",
                                }}
                                value={item_image_path2}
                            />

                            <span className="btn btn-primary btn-file wbt"
                                style={{
                                    whiteSpace: "nowrap",
                                    width: "fit-content"
                                }}>
                                {intl.formatMessage({ id: "104025", defaultMessage: "Upload/Edit" })}
                                <input type="file" onChange={handleChangeItem_image_path2} />
                            </span>

                            <button
                                type="button"
                                className="btn btn-danger wbt"
                                onClick={removeImageItem_image_path2}
                            >
                                {intl.formatMessage({ id: "104026", defaultMessage: "delete" })}
                            </button>
                            <p style={{ position: 'absolute', marginTop: '40px' }}>ไม่ควรเกิน 1 MB</p>
                        </div>
                    </div>

                    <div
                        style={{
                            display: "block",
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: "50%",
                        }}
                    >
                        {stateItem_image_path2.imageURLItem_image_path ? (
                            <img
                                style={{
                                    width: "150px",
                                }}
                                src={stateItem_image_path2.imageURLItem_image_path}
                            />
                        ) : item_image_path2 ? (
                            <img
                                style={{
                                    width: "150px",
                                }}
                                src={item_image_path2}
                            />
                        ) : null}
                    </div>

                    <div className="form-inline" style={{ marginBottom: '25px' }}>
                        <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "เวลาเริ่มต้น" })} <span style={{ color: "red" }}>
                                *
                            </span>:{' '}
                        </p>
                        <div className="form-inline" style={{ marginBottom: "25px" }}>
                            <input id="datestart" type="datetime-local" defaultValue="yyyy-mm-dd" style={{ height: "38px", width: "185px", backgroundColor: "#F4F6F9", borderRadius: "5px", borderWidth: "0" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={(data) =>
                                    setPopupstart(data.target.value === "NULL" ? null : data.target.value)
                                }
                            />
                        </div>


                    </div>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "เวลาสิ้นสุด" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
                        </p>
                        <input id="datestart" type="datetime-local" min={popupstart} defaultValue="yyyy-mm-dd" style={{ height: "38px", width: "185px", backgroundColor: "#F4F6F9", borderRadius: "5px", borderWidth: "0" }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(data) =>
                                setPopupend(data.target.value === "NULL" ? null : data.target.value)
                            }
                        />
                        {/*<TextField
                            id="DateFrom"
                            type="date"
                            label={intl.formatMessage({ id: "102011", defaultMessage: "Date From" })}
                            className=" mb-3 mr-3"
                            value={popupend}
                            style={{
                                height: '38px',
                                width: '185px',
                                backgroundColor: '#F4F6F9',
                                borderRadius: '5px',
                                borderWidth: '0'
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            onChange={name => {
                                setPopupend(name.target.value)
                            }}
                        />
                        <div>
                            <TimePicker
                                disableClock={true}
                                onChange={setPopupendTime}
                                value={popupendTime}
                            />
                        </div>*/}
                    </div>


                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                            {intl.formatMessage({ id: "###", defaultMessage: "คะแนนที่ได้รับ" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
                        </p>
                        <input
                            type={'number'}
                            name="topic"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={point}
                            onChange={(e) => {
                                if (e.target.value >= 0) {
                                    setPoint(e.target.value)

                                }
                            }}
                        />
                        <p style={{ position: 'absolute', marginTop: '75px', marginLeft: '250px' }}>(ไม่สามารถให้คพแนนต่ำกว่า 0 ได้)</p>
                    </div>

                    <div className="form-inline" style={{ marginBottom: '25px' }}>
                        <p style={{ marginTop: '15px', float: 'left', width: '20%' }}>
                            <span style={{ color: "red" }}>

                            </span>
                            ลำดับการแสดง
                        </p>
                        <input
                            name="displayOrder"
                            type="number"
onKeyDown={e => symbolsArr.includes(e.key) && e.preventDefault()}

                            style={{
                                height: '38px',
                                width: '530px',
                                backgroundColor: '#F4F6F9',
                                borderRadius: '5px',
                                borderWidth: '0'
                            }}
                            value={displayOrder}
                            onChange={displayOrder => {
                                if (displayOrder.target.value >= 0) {
                                    setDisplayOrder(displayOrder.target.value)
                                }
                            }
                            }
                        />
                    </div>


                    <Link to="/Weeklypass">
                        <button type="button" className="btn btn-secondary wbt mr-5">
                            {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
                        </button>
                    </Link>
                    <button className="btn btn-primary" onClick={() => onSubmit()}>
                        {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
                    </button>
                </CardBody>
            </Card>
        </>
    );
};
